// ============= Hooks =============

import { useAppTheme } from '@/hooks/useAppTheme';

/**
 * Landing-page layout-axis hook. Delegates to the shared {@link useAppTheme}
 * so the landing page stays in sync with the rest of the app rather than
 * maintaining a duplicate localStorage listener.
 */
export const useLandingPageTheme = () => {
  const { themeMode, isCompactTheme, setLayoutMode } = useAppTheme();
  return { themeMode, isCompactTheme, setThemeMode: setLayoutMode };
};
